;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('dropdownSupport', dropdownSupport)

  /* @ngInject */
  function dropdownSupport ($window, IntercomService) {
    return {
      restrict: 'EA',
      scope: true,
      templateUrl: '/core/directives/dropdown-support/dropdown-support-directive.html?$$REVISION$$',
      link: function (scope, element, attributes) {
        scope.openKnowledgeBase = (locale) => {
          let url = 'http://ajuda.deskfy.io/'
          if (locale === 'EN-US') {
            url = 'http://ajuda.deskfy.io/pt-BR/articles/3931192-deskfy-s-walkthrough-for-admins'
          }
          $window.open(url, '_blank')
        }

        scope.openPrivacyPolicy = () => {
          $window.open('https://www.deskfy.io/pol%C3%ADtica-de-privacidade', '_blank')
        }

        scope.openIntercomChat = () => {
          IntercomService.show()
        }

        scope.openProductNews = () => {
          $window.open('https://news.intercom.com/deskfy', '_blank')
        }
      }
    }
  }
})()
